export default "__VITE_ASSET__nwOOjgj6__"